import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = () => (
  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 2.33333L1.16667 6.16667L0 5L5 0L10 5L8.83333 6.16667L5 2.33333Z" fill="#0B57D0" />
  </svg>
);

export default Icon;
